const Door = ({ handleTraitChange, trait }) => {
  return (
    <div>
      <p>Door</p>
      <select
        name="doors"
        className="form-control mb-3"
        onChange={(e) => handleTraitChange(e)}
        defaultValue={trait.doors / trait.pixels}
      >
        <option value="0">none</option>
        <option value="1">yes</option>
      </select>
      <div className="row" style={{ display: !trait.doors ? "none" : "flex" }}>
        <div className="col">
          <label>Door Height (inches)</label>
          <input
            defaultValue={trait.doorH / trait.pixels}
            className="form-control mb-3"
            type="number"
            name="doorH"
            step=".5"
            min="10"
            onChange={(e) => handleTraitChange(e)}
          ></input>
          <label>Door Width</label>
          <select
            name="doorW"
            className="form-control mb-3"
            onChange={(e) => handleTraitChange(e)}
            defaultValue={trait.doorW / trait.pixels}
          >
            <option value="38">36"</option>
            <option value="34">32"</option>
            <option value="32">30"</option>
          </select>
          <label>Header</label>
          <select
            defaultValue={trait.header / trait.pixels}
            className="form-control mb-3"
            type="number"
            name="header"
            onChange={(e) => handleTraitChange(e)}
          >
            <option value="5.5">2 x 6</option>
            <option value="7.25">2 x 8</option>
            <option value="9.25">2 x 10</option>
            <option value="11.25">2 x 12</option>
          </select>
          <label>Header Amount</label>
          <select
            defaultValue={trait.headerAmount / trait.pixels}
            className="form-control mb-3"
            type="number"
            name="headerAmount"
            onChange={(e) => handleTraitChange(e)}
          >
            <option value="0">SINGLE</option>
            <option value="1">DOUBLE</option>
            <option value="2">TRIPLE</option>
            <option value="3">NONE</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Door;
